import { InjectionToken } from '@angular/core';

export const ENVIRONMENT = new InjectionToken<{}>('Environment');
